export default {
	UserDetail: {
		PhoneNumber: 'Số điện thoại',
		Email: 'Email',
		FirstName: 'Họ và đệm',
		LastName: 'Tên',
		Role: 'Vai trò',
		Admin: 'Quản trị',
		User: 'Người dùng',
		Position: 'Chức vụ',
		Cancel: 'Hủy bỏ',
		Save: 'Lưu',
		AddUser: 'Thêm người dùng',
		EditUser: 'Sửa người dùng',
		titleConfirmMisaID:
			' đã được sử dụng bởi người dùng dưới đây. Đây có phải người dùng bạn muốn thêm?',
		Accept: 'Thêm',
		ConfirmAddUserAmis: (email, phone) =>
			`Bạn có chắc chắn muốn thêm người dùng <strong>${[email, phone].filter(Boolean).join('/')}</strong>`,
		WarningAdminUserExist: (email, phone) =>
			`Người dùng <strong>${[email, phone].filter(Boolean).join('/')}</strong> là quản trị và đã tồn tại ở danh sách.`,
		AmisUserNotAuthorized: (email, phone) =>
			`Người dùng <strong>${[email, phone].filter(Boolean).join('/')}</strong> chưa được phân quyền vào ứng dụng. Vui lòng liên hệ Quản trị hệ thống để được phân quyền vào ứng dụng`,
		AmisUserIsAdmin: (email, phone) =>
			`Người dùng <strong>${[email, phone].filter(Boolean).join('/')}</strong> là quản trị và đã tồn tại ở danh sách.`,
		Ignore: 'Bỏ qua',
		EmployeeSearch: 'Tìm kiếm nhân viên...',
		ColName: 'Họ tên',
		ColPhone: 'Số điện thoại',
		ColEmail: 'Email',
		ColEmployeeCode: 'Mã nhân viên',
		ColRole: 'Vai trò',
		ColUserName: 'Tên đăng nhập',
		SearchAmisUser: 'Tìm kiếm theo tên/email/SĐT',
		AddUserAmis: 'Chọn người dùng từ hệ thống AMIS',
		UserExistInTrash:
			'Người dùng đã tồn tại trong Thùng rác của hệ thống. Vui lòng vào AMIS Hệ thống để khôi phục người dùng trước khi thêm mới.'
	},
	UserList: {
		UserManager: 'Quản lý người dùng',
		ListUserLogin: 'Danh sách người dùng đăng nhập MISA mTax',
		AddUser: 'Thêm người dùng',
		ConfirmWhenDelete: value =>
			`Người dùng này sẽ không được tiếp tục làm việc với mã số thuế ${value} nữa. Bạn có chắc chắn muốn xóa?`,
		ConfirmWhenActive: value =>
			`Người dùng được kích hoạt sẽ được phép làm việc với mã số thuế ${value}`,
		ConfirmWhenInActive: value =>
			`Người dùng bị ngừng kích hoạt sẽ không được phép làm việc với mã số thuế ${value} cho đến khi được kích hoạt trở lại`,
		Active: 'Kích hoạt',
		Deactivate: 'Ngừng kích hoạt'
	},
	DeleteUser: {
		DeleteUser: 'Xóa người dùng',
		Cancel: 'Hủy bỏ',
		ContentWarringDelete: value =>
			`Người dùng này sẽ không được tiếp tục làm việc với mã số thuế <strong> ${value}. </strong> Bạn có chắc chắn muốn xóa?`,
		Success: 'Xóa người dùng thành công'
	}
};
